import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-container px-container my-10 md:my-16" }
const _hoisted_2 = { class: "flex flex-col md:flex-row items-center" }
const _hoisted_3 = { class: "w-full md:w-1/2" }
const _hoisted_4 = { class: "md:ml-12 lg:ml-24 space-y-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", { class: "text-3xl font-bold" }, "Oferta especial FILMIN", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-xl mb-24" }, " Amplía tu experiencia Atlàntida Mallorca Film Fest disfrutando del festival online en Filmin durante un mes por un precio especial de 5€ ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Suscribirme ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BonoBannerStripe = _resolveComponent("BonoBannerStripe")
  const _component_ImageCard = _resolveComponent("ImageCard")
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BonoBannerStripe, {
      class: "text-4xl sm:text-5xl lg:text-6xl text-center md:mb-10",
      text: "Oferta."
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_ImageCard, {
          class: "mb-14 mt-14 md:mb-0 mx-8 md:mx-0",
          rotate: "",
          src: `${_ctx.baseURL}img/bono/tarjeta-bono.png?date=2022-07-06`,
          srcset: 
            [
              `${_ctx.baseURL}img/bono/tarjeta-bono.png?date=2022-07-06 1x`,
              `${_ctx.baseURL}img/bono/tarjeta-bono@2x.png?date=2022-07-06 2x`,
              `${_ctx.baseURL}img/bono/tarjeta-bono@3x.png?date=2022-07-06 3x`,
            ].join(', ')
          
        }, null, 8, ["src", "srcset"])
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_Button, {
          color: "filmin-green",
          class: "mb-6 mr-6 md:mb-0",
          href: "https://www.filmin.es/landings/amff22",
          as: _ctx.AnchorLink
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_ArrowIcon, {
              fill: "currentColor",
              class: "ml-2 w-4 h-4"
            })
          ]),
          _: 1
        }, 8, ["as"])
      ])
    ])
  ]))
}